"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizedOfficer = void 0;
var joi_1 = __importDefault(require("joi"));
exports.authorizedOfficer = joi_1.default.object({
    email: joi_1.default.string()
        .min(0)
        .max(80)
        .email({ tlds: { allow: false } }),
    extension: joi_1.default.string()
        .min(0)
        .max(5)
        .optional()
        .allow(''),
    faxNumber: joi_1.default.string()
        .min(0)
        .max(10)
        .optional()
        .allow(''),
    firstName: joi_1.default.string()
        .min(0)
        .max(15),
    lastName: joi_1.default.string()
        .min(0)
        .max(25),
    phoneNumber: joi_1.default.string()
        .min(0)
        .max(10),
    position: joi_1.default.number()
        .integer()
        .options({ convert: false }),
});
exports.default = { authorizedOfficer: exports.authorizedOfficer };
